export default {
    MAX_DIFF_TIME_WITH_SCAN_BARCODE: 100,
    SET_BARCODE_STRING: "[SCAN] SET BARCODE STRING",
    SET_SCAN_PAGE: "[SCAN] SET SCAN PAGE",
    SCAN_PAGES: {
        PRODUCT: "PRODUCT",
        CUSTOMER: "CUSTOMER",
        ORDER: "ORDER",
        ONHOLD_ORDER: "ONHOLD_ORDER"
    }
}



// WEBPACK FOOTER //
// ./src/view/constant/ScanConstant.js